export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Buscar"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Estás en modo Demo. Los saldos y las operaciones son de práctica."])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ir al gabinete de trabajo"])}
}